export default __webpack_public_path__ + "static/media/ITR-4.df0ec264.png";